import useFetchHelpCenter from './fetch/useFetchHelpCenter';

export default function useNBA() {
  const { data } = useFetchHelpCenter();
  const next_best_action = data?.next_best_action;
  return next_best_action;
}
